module.exports = __webpack_public_path__ + "img/new_index_service_bg1.88d22e08.png";